import projection from '../generated/pw2504f1.json'; import { AcceptanceManifest } from '../types';
export const pw2504f1AcceptanceManifest = projection as AcceptanceManifest;
